export function getEventStatus(date, time) {
    if (!date) return 'upcoming';
    const eventDateTime = new Date(time ? `${date}T${time}` : date);
    return eventDateTime < new Date() ? 'past' : 'upcoming';
}
